import { Sparkle } from '../render/primitives';

/** Official Helium roundel, used directly from the design-system asset. */
export function Roundel({ size = 32 }: { size?: number }) {
  return (
    <img
      src="/assets/roundel-purple-official.svg"
      width={size}
      height={size}
      alt="Helium"
      style={{ display: 'block', flexShrink: 0 }}
    />
  );
}

/** The AI avatar tile (gradient square with a sparkle). */
export function AiTile({ size = 40, radius = 12 }: { size?: number; radius?: number }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        flexShrink: 0,
        background: 'linear-gradient(145deg, #5F26FC, #2a0a7a)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 'inset 0 0 0 1px rgba(255,255,255,.12)',
      }}
    >
      <Sparkle size={size * 0.5} color="#fff" />
    </div>
  );
}

/** Round avatar showing a user's initials (purple circle, white bold text). */
export function InitialsAvatar({ initials, size = 34, fontSize = 13 }: { initials: string; size?: number; fontSize?: number }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        background: 'var(--he-purple)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize,
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
}

/**
 * Small "Beta" tag shown beside the "AI" pill in the app chrome. Flat filled
 * pill (no border) so it reads as secondary to the accent "AI" mark.
 */
export function BetaTag({ fontSize = 11 }: { fontSize?: number }) {
  return (
    <span
      style={{
        fontSize,
        fontWeight: 600,
        color: 'var(--fg-2)',
        background: 'var(--bg-3)',
        padding: '2px 7px',
        borderRadius: 999,
        letterSpacing: '.01em',
      }}
    >
      Beta
    </span>
  );
}

/** Right-pointing chevron used on drill-in rows (profile, sidebar account). */
export function ChevronRight({ size = 15 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M9 6l6 6-6 6" stroke="var(--fg-3)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
